import { ChevronUp, ChevronDown } from 'lucide-react';
import { C, FONTS } from '../../tokens/design';

export function TH({ cols }) {
  return (
    <thead>
      <tr style={{ borderBottom: `1px solid ${C.b1}`, background: `${C.s2}80` }}>
        {cols.map(c => (
          <th key={c} style={{
            padding: '9px 13px', textAlign: 'left',
            fontSize: 10, color: C.t2, fontWeight: 600,
            textTransform: 'uppercase', letterSpacing: 0,
            fontFamily: FONTS.mono, whiteSpace: 'nowrap',
          }}>{c}</th>
        ))}
      </tr>
    </thead>
  );
}

export function SortableTH({ columns, sortKey, sortDir, onSort }) {
  return (
    <thead>
      <tr style={{ borderBottom: `1px solid ${C.b1}`, background: `${C.s2}80` }}>
        {columns.map(col => {
          const isActive = col.key && sortKey === col.key;
          return (
            <th
              key={col.label}
              onClick={col.key ? () => onSort(col.key) : undefined}
              style={{
                padding: '9px 13px', textAlign: 'left',
                fontSize: 10, color: isActive ? C.t1 : C.t2, fontWeight: 600,
                textTransform: 'uppercase', letterSpacing: 0,
                fontFamily: FONTS.mono, whiteSpace: 'nowrap',
                cursor: col.key ? 'pointer' : 'default',
                userSelect: 'none',
              }}
            >
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3 }}>
                {col.label}
                {isActive && (sortDir === 'asc' ? <ChevronUp size={12} /> : <ChevronDown size={12} />)}
              </span>
            </th>
          );
        })}
      </tr>
    </thead>
  );
}

export function TR({ onClick, children, style = {}, hover = true }) {
  return (
    <tr
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : 'default',
        borderBottom: `1px solid ${C.b2}`,
        transition: 'background 0.12s ease, box-shadow 0.12s ease',
        ...style,
      }}
      onMouseEnter={e => {
        if (!hover) return;
        e.currentTarget.style.background = C.s2;
        e.currentTarget.style.boxShadow = `inset 2px 0 0 ${C.sky}55`;
      }}
      onMouseLeave={e => {
        if (!hover) return;
        e.currentTarget.style.background = style.background || 'transparent';
        e.currentTarget.style.boxShadow = style.boxShadow || 'none';
      }}
    >{children}</tr>
  );
}

export function TD({ children, style = {} }) {
  return <td style={{ padding: '10px 13px', verticalAlign: 'middle', ...style }}>{children}</td>;
}
